import script from './SdsContentLoader.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"sds-content-loader",class:( _obj = {}, _obj[("sds-content-loader--" + _vm.size)] = !!_vm.size, _obj ),attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"contentLoader"}},[_c('path',{attrs:{"fill":"currentColor","id":"Background","opacity":"0.15","fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 14C11.3137 14 14 11.3137 14 8.00001C14 4.6863 11.3137 2.00001 8 2.00001C4.68629 2.00001 2 4.6863 2 8.00001C2 11.3137 4.68629 14 8 14ZM8 15.3333C12.0501 15.3333 15.3333 12.0501 15.3333 8.00001C15.3333 3.94992 12.0501 0.666672 8 0.666672C3.94991 0.666672 0.666668 3.94992 0.666668 8.00001C0.666668 12.0501 3.94991 15.3333 8 15.3333Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"currentColor","id":"Spinner","fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.66658 3.01119C5.65328 2.3519 6.81332 2.00001 8 2.00001V0.666672C6.54961 0.666672 5.13178 1.09676 3.92582 1.90256C2.71986 2.70836 1.77993 3.85367 1.22489 5.19366C0.854583 6.08766 0.666691 7.04152 0.666668 7.99988C0.666668 7.99983 0.666668 7.99992 0.666668 7.99988L2 8.00001C2.00001 7.21586 2.15374 6.43539 2.45673 5.7039C2.91085 4.60755 3.67989 3.67048 4.66658 3.01119Z"}})])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-827c9fce_0", { source: ".sds-content-loader[data-v-827c9fce]{animation:loading-data-v-827c9fce 2s cubic-bezier(.3,0,.3,1) infinite}.sds-content-loader--xs[data-v-827c9fce]{width:16px;height:16px}.sds-content-loader--sm[data-v-827c9fce]{width:20px;height:20px}.sds-content-loader--md[data-v-827c9fce]{width:24px;height:24px}.sds-content-loader--lg[data-v-827c9fce]{width:48px;height:48px}@keyframes loading-data-v-827c9fce{to{transform:rotate(1080deg)}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-827c9fce";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
